<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text }}
        </v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <v-data-table :loading="loading" :headers="ventas" :items="reporteBien" :items-per-page="15" class="elevation-3"
          :search="buscar" dense>
          <template v-slot:top>
            <v-form v-model="isValid">
              <v-toolbar flat>
                <!-- Formulario busqueda de bienes activos -->
                <v-toolbar-title class="hidden-sm-and-down">REPORTE BIENES ACTIVOS</v-toolbar-title>
                <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
                <v-spacer />
                <!-- Formulario busqueda de movimiento caja -->
                <v-text-field class="text-xs-center" v-model.trim="buscar" append-icon="search" dense clearable
                  label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer />
                <v-checkbox color="internal" v-model="finterno" label="Cód. Interno" :disabled="desabilitar || !isValid"
                  @click="listar" dense hide-details></v-checkbox>
                <!-- Fin Formulario busqueda de movimiento caja -->
                <v-spacer />

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small color="info" @click="listar" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" class="mr-1" v-bind="attrs" v-on="on">
                      <v-icon>update</v-icon>
                    </v-btn>
                  </template>
                  <span>Actualizar Reporte</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small color="success" @click="crearXLSX()" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" v-bind="attrs" v-on="on">
                      <v-icon>summarize</v-icon>
                    </v-btn>
                  </template>
                  <span>Reporte Excel</span>
                </v-tooltip>
                <!-- Fin Formulario Busqueda de bienes activos-->
              </v-toolbar>
            </v-form>
          </template>
          <!-- Formatear detalle -->
          <template v-slot:item.codbien="{ item }">
            <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
          </template>

          <template v-slot:item.fec_act="{ item }">
            <span>{{ item.fec_act | formatearFecha }}</span>
          </template>
          <!-- Fin Formatear detalle -->
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex"; //Importamos para llamar a los elementos
import moment from "moment";
import ExcelJS from 'exceljs';

export default {
  data() {
    return {
      reporteBien: [],
      dialog: false,
      ventas: [
        { text: "C. Patrimonial", value: "codbien", sortable: false, width: 135 },
        { text: "C/Int.", value: "codinterno", sortable: false },
        { text: "Tipo Bien", value: "tbdescripcion", sortable: false },
        { text: "Local", value: "nomlocales", sortable: false },
        { text: "Area", value: "nomareas", sortable: false },
        { text: "Oficina", value: "nomoficinas", sortable: false },
        { text: "Usuario", value: "nickname", sortable: false },
        { text: "FEC. ACTUALIZADO", value: "fec_act", sortable: false },
      ],

      buscar: "",

      desabilitar: false,
      isValid: true,
      loading: false,
      alerta: { snackbar: false, color: "", text: "" },

      finterno: false,

      fechaActual: moment().format("DDMMYYYY_HHmm"),
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]), // Llamamos a state
  },

  created() {
    this.listar();
  },

  methods: {
    /* Listar bienes activos */
    listar() {
      let me = this;
      me.desabilitar = true;
      me.loading = true;

      axios.get("api/Bienes/ReporteBien", {
        params: {
          idempresa: me.usuarioState.idempresa,
          finterno: me.finterno
        },
      })
        .then(function (response) {
          me.reporteBien = response.data;
          me.desabilitar = false;
          me.loading = false;
          //console.log(me.reporteBien);
        })
        .catch((err) => {
          me.desabilitar = false;
          me.loading = false;
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "Ocurrio un error";
          //console.log(err.response);
        });
    },
    /* Fin Listar bienes activos */

    /* Crear excel */
    async crearXLSX() {
      // Estilo para el título principal
      const titleStyle = {
        font: { name: 'Calibri', size: 16, bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
      };

      // Estilo para las cabeceras de la tabla de depreciación
      const tableHeaderStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6E0B4' } }, // Color verde claro
      };

      // 1. Crear un nuevo libro y una hoja de cálculo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Reporte Bienes Activos');

      // Crear una imagen de base64
      const Base64 = 'data:image/png;base64,' + this.empresaState.logo;
      const logoImage = workbook.addImage({
        base64: Base64,
        extension: 'jpeg',
      });

      // Agregar la imagen a la hoja de cálculo
      worksheet.addImage(logoImage, {
        ext: { width: 50, height: 65 },
      });

      // 2. Definir el ancho de las columnas para que se ajusten al contenido
      worksheet.getColumn('A').width = 6;
      worksheet.getColumn('B').width = 15;
      worksheet.getColumn('C').width = 15;
      worksheet.getColumn('D').width = 50;
      worksheet.getColumn('E').width = 15;
      worksheet.getColumn('F').width = 30;
      worksheet.getColumn('G').width = 12;
      worksheet.getColumn('H').width = 12;
      worksheet.getColumn('I').width = 15;
      worksheet.getColumn('J').width = 10;
      worksheet.getColumn('K').width = 18;
      worksheet.getColumn('L').width = 50;
      worksheet.getColumn('M').width = 11;
      worksheet.getColumn('N').width = 13;
      worksheet.getColumn('O').width = 10;
      worksheet.getColumn('P').width = 15;
      worksheet.getColumn('Q').width = 15;
      worksheet.getColumn('R').width = 15;
      worksheet.getColumn('S').width = 15;
      worksheet.getColumn('T').width = 20;
      worksheet.getColumn('U').width = 15;
      worksheet.getColumn('V').width = 18;
      worksheet.getColumn('W').width = 20;
      worksheet.getColumn('X').width = 15;
      worksheet.getColumn('Y').width = 13;
      worksheet.getColumn('Z').width = 20;
      worksheet.getColumn('AA').width = 15;
      worksheet.getColumn('AB').width = 15;
      worksheet.getColumn('AC').width = 12;
      worksheet.getColumn('AD').width = 15;
      worksheet.getColumn('AE').width = 12;
      worksheet.getColumn('AF').width = 20;
      worksheet.getColumn('AG').width = 30;
      worksheet.getColumn('AH').width = 35;
      worksheet.getColumn('AI').width = 10;
      worksheet.getColumn('AJ').width = 18;
      worksheet.getColumn('AK').width = 35;
      worksheet.getColumn('AL').width = 35;
      worksheet.getColumn('AM').width = 30;
      worksheet.getColumn('AN').width = 10;
      worksheet.getColumn('AO').width = 35;
      worksheet.getColumn('AP').width = 10;
      worksheet.getColumn('AQ').width = 12;
      worksheet.getColumn('AR').width = 12;
      worksheet.getColumn('AV').width = 15;

      // 2. Añadir el título principal y combinar celdas
      worksheet.addRow(['REPORTE DE BIENES ACTIVOS']);
      worksheet.mergeCells('A1:AV1');
      worksheet.getCell('A1').style = titleStyle;
      worksheet.getRow(1).height = 60;

      // 3. Añadir un espacio y la cabecera de la tabla
      const headerRow = worksheet.addRow(['ITEM', 'RUC ENTIDAD', 'CÓDIGO PATRIMONIAL', 'DESCRIPCIÓN', 'ACTOS DE ADQUISICIÓN QUE GENERAN ALTA', 'NRO DOC ADQUISICIÓN', 'FECHA ADQUISICIÓN', 'VALOR ADQUISICIÓN', 'TIPO USO CUENTA', 'TIPO CUENTA', 'NRO CUENTA CONTABLE', 'DENOMINACIÓN', 'ASEGURADO', 'ESTADO DE CONSERVACIÓN', 'CONDICIÓN',
        'MARCA', 'MODELO', 'TIPO', 'COLOR', 'SERIE', 'DIMENSIÓN LONG-ALT-ANCHO', 'PLACA/MATRICULAS', 'NRO MOTOR', 'NRO CHASIS', 'AÑO FABRICACIÓN', 'CARROCERIA', 'NRO EJES', 'COMBUSTIBLE', 'TRANSMISIÓN', 'CILINDRADA', 'KILOMETRAJE', 'TARJETA PROPIEDAD', 'OTRAS CARACTERISTICAS', 'OBSERVACIÓN', 'SITUACIÓN',
        'FECHA ACTUALIZADO', 'LOCALES', 'AREAS', 'OFICINAS', 'NRO DOC.', 'PERSONAL', 'USUARIO', 'SEGUIMIENTO', 'CÓDIGO INTERNO', 'GRUPO', 'CLASE', 'FAMILIA', 'CLASIF. PRESUP. GASTO']);
      headerRow.eachCell(cell => {
        headerRow.eachCell((cell, colNumber) => {
          cell.style = {
            ...tableHeaderStyle,
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: colNumber <= 36 ? 'FFC6E0B4' : 'FFFCE4D6' // Verde claro y anaranjado claro
              }
            }
          };
        });
      });

      // 4. Añadir los datos de la tabla
      let itemCounter = 1;

      this.reporteBien.forEach(rowData => {

        const row = worksheet.addRow([
          itemCounter++,
          this.empresaState.ruc,
          rowData.codbien.length == '12' ? rowData.codbien : rowData.codbienint + '-' + rowData.codinterno,
          rowData.tbdescripcion,
          rowData.flg_cond,
          rowData.doc_alta,
          moment(rowData.fec_reg).format("DD/MM/YYYY"),
          rowData.valordq,
          "DE USO " + this.usuarioState.tipoempresa,
          rowData.tipo_cta,
          rowData.cuenta,
          rowData.cdenominacion,
          rowData.asegurado == "S" ? "SI" : "NO",
          rowData.flg_estado,
          rowData.est_bien,

          rowData.marca,
          rowData.modelo,
          rowData.tipo,
          rowData.color,
          rowData.serie,
          rowData.dimension,

          rowData.placa,
          rowData.nummotor,
          rowData.numchasis,
          rowData.ano,
          rowData.carroceria,
          rowData.nro_ejes,
          rowData.combustible,
          rowData.transmision,
          rowData.cilindrada,
          rowData.kilometraje,
          rowData.tarjeta_propiedad,

          rowData.otras_caract,
          rowData.observacion,
          rowData.situacion,
          moment(rowData.fec_act).format("DD/MM/YYYY HH:mm:ss"),
          // FUERA DE FORMATO
          rowData.nomlocales,
          rowData.nomareas,
          rowData.nomoficinas,
          rowData.pnrodoc,
          rowData.pnombres,
          rowData.nickname,
          rowData.seguimiento == true ? "Verificado" : "No verficado",
          rowData.codinterno,
          rowData.grupo,
          rowData.clase,
          rowData.familia,
          rowData.clasif_presup_gasto
        ]);

        // Aplicar estilos y bordes
        function aplicarBorde(row, startCol, endCol, colorARGB) {
          for (let col = startCol; col <= endCol; col++) {
            const cell = row.getCell(col);
            cell.border = {
              top: { style: 'thin', color: { argb: colorARGB } },
              left: { style: 'thin', color: { argb: colorARGB } },
              bottom: { style: 'thin', color: { argb: colorARGB } },
              right: { style: 'thin', color: { argb: colorARGB } },
            };
          }
        }
        aplicarBorde(row, 1, 36, 'FFC6E0B4');    // Bordes verde claro en columnas 1 a mas
        aplicarBorde(row, 37, 48, 'FFFCE4D6');

        // Centrar la celda
        [1, 2, 3, 5, 7, 10, 13, 14, 15, 35, 36, 40, 42, 45, 46, 47].forEach(col => {
          row.getCell(col).alignment = { horizontal: 'center' };
        });

        // Formato y estilo para columnas
        [8].forEach(col => {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00'; // incluye símbolo de soles
          cell.alignment = { horizontal: 'right' };
          cell.font = { name: 'Calibri', size: 11 };
        });
      });

      // Ocultar las líneas de división de la hoja de cálculo
      worksheet.views = [
        {
          showGridLines: false
        }
      ];

      // 7. Generar el archivo y descargarlo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte Bienes Activos.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /* Fin Crear excel */
  },
};
</script>
